import React, { useContext, type JSX } from 'react';

import clearFavoritUtvalMutationDoc from './clearFavoritUrvalMutation.gql';
import {
  ClearFavoritUrvalMutation as IClearFavoritUrvalMutationData,
  ClearFavoritUrvalMutationVariables as IClearFavoritUrvalMutationVariables,
} from './_QueryTypes/ClearFavoritUrvalMutation';
import { useMutation } from '@apollo/client';
import { ActiveDatabaseContext } from '../../../../../../../ActiveDatabaseContext/ActiveDatabaseContext';

export type ClearFavoritUrvalType = (urvalId: string, rutinId: number) => void;
interface IProps {
  children: (clearFavoritUrval: ClearFavoritUrvalType) => JSX.Element;
}

export const useClearFavoritUrval = (): ClearFavoritUrvalType => {
  const [mutateFn] = useMutation<
    IClearFavoritUrvalMutationData,
    IClearFavoritUrvalMutationVariables
  >(clearFavoritUtvalMutationDoc);
  const avtiveDatabaseContext = useContext(ActiveDatabaseContext);

  return (urvalId, rutinID) => {
    if (avtiveDatabaseContext.activeDatabase) {
      mutateFn({
        variables: { dbname: avtiveDatabaseContext.activeDatabase, rutinID },
        // Need to manually update cache here because response is always null
        update: (cache, result) => {
          if (result.errors == null) {
            cache.modify({
              id: cache.identify({ __typename: 'TEDSelection', id: urvalId }),
              fields: { anvFavorit: () => false },
            });
          }
        },
        optimisticResponse: { clearfavoritselection: null },
      });
    }
  };
};

const ClearFavoritUrvalMutation: React.FC<IProps> = props => {
  const clearFavoritUrval = useClearFavoritUrval();

  return props.children(clearFavoritUrval);
};

export default ClearFavoritUrvalMutation;
